import React from "react";
import { Box, Container } from "@cloudscape-design/components";
import SectionHeader from "../SectionHeader";

interface PlaceholderSectionProps {
  title: string;
  placeholderTitle: string;
  message: string;
}

/**
 * Displays a placeholder section with title and message for empty states
 * @param title - Main section title
 * @param placeholderTitle - Placeholder content title
 * @param message - Descriptive message for the placeholder state
 */
export const PlaceholderSection: React.FC<PlaceholderSectionProps> = ({
  title,
  placeholderTitle,
  message
}) => (
  <Box>
    <SectionHeader title={title} variant="h2" />
    <Container>
      <Box padding="xxl" textAlign="center">
        <Box variant="h3" margin={{ bottom: "s" }}>
          {placeholderTitle}
        </Box>
        <Box color="text-status-info" fontSize="body-s">
          {message}
        </Box>
      </Box>
    </Container>
  </Box>
);
